/** The upload rows the Invoices page tracks, kept per browser tab so a quick photo shows up there too. */
export const UPLOADS_KEY = 'invoices_recent_uploads';

export function loadUploads() {
  try { return JSON.parse(sessionStorage.getItem(UPLOADS_KEY) || '[]'); } catch { return []; }
}

export function saveUploads(rows) {
  try { sessionStorage.setItem(UPLOADS_KEY, JSON.stringify(rows.slice(0, 20))); } catch { /* storage off */ }
}

export function rememberUploads(rows) {
  saveUploads([...rows, ...loadUploads()]);
}
